import { createAction } from '@reduxjs/toolkit';
export const resetSensorList = createAction('sensors/resetSensorList');
export const getSensorsList = createAction('sensors/getSensorsList');
export const getSensorsListResolved = createAction('sensors/getSensorsList/resolved');
export const getSensorsListRejected = createAction('sensors/getSensorsList/rejected');
